export const formatCardTitle = (title) => {
  if (typeof title === 'string') {
    return title.trim();
  }
  return title;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Card/utils/cardHelpers.js